import React from 'react'
import moment from 'moment'
import ArchiveList from './ArchiveList.jsx'
import Loading from './Loading.jsx'
import SearchBar from './SearchBar.jsx'

require('../css/venuePage.css')

var CurrentArchive = React.createClass({
  propTypes: {
    video: React.PropTypes.object.isRequired
  },
  render: function() {
    var duration = moment().startOf('day').seconds(this.props.video.duration).format('H:mm:ss')
    if (!this.props.video.thumbnailLink) {
      this.props.video.thumbnailLink = '//cdn2.streamspot.com/streamspot-od-w-circles-160x90.png'
    }
    if(this.props.video.custom_name){
      return (
        <li className='video-list-item'>
          <div className="meta">
            <a className="src-link">
              <p className="name">{this.props.video.custom_name}</p>
              <p className="date">{this.props.video.date}</p>
              <p className="time">{this.props.video.time}</p>
              <p className="duration">Duration: {duration}</p>
            </a>
          </div>
          <div className="thumb">
            <a>
              <div className="thumb-wrapper">
                <div className="play-button">
                  <i className="fa fa-play"></i>
                </div>
                <img width="140" height="79" className="lazyload video-image-sidebar" src={this.props.video.thumbnailLink} alt={this.props.video.custom_name}
                aria-label={this.props.video.custom_name} />
                <div className="image-after"></div>
              </div>
            </a>
          </div>
        </li>
      )
    }else{
      return (
        <li className='video-list-item'>
          <div className="meta">
            <a className="src-link">
              <p className="date">{this.props.video.date}</p>
              <p className="time">{this.props.video.time}</p>
              <p className="duration">Duration: {duration}</p>
            </a>
          </div>
          <div className="thumb">
            <a>
              <div className="thumb-wrapper">
                <div className="play-button">
                  <i className="fa fa-play"></i>
                </div>
                <img width="140" height="79" className="lazyload video-image-sidebar" src={this.props.video.thumbnailLink}
                alt={this.props.video.date} aria-label={this.props.video.date}/>
                <div className="image-after"></div>
              </div>
            </a>
          </div>
        </li>
      )
    }
  }
})


var NowPlaying = React.createClass({
  getInitialState: function() {
    var video = null
    if(this.props.player && this.props.player.video){
      video = this.props.player.video
    } else if(this.props.player) {
      video = {
        custom_name: this.props.player.broadcaster.name + ' Live Broadcast',
        src: this.props.player.broadcaster.live_src,
        live: true,
        type: 'application/x-mpegurl'
      }
    }
    return {
      listener: null,
      video: video
    }
  },
  componentDidMount: function() {
    this.setState({
      listener: this.props.player.emitter.addListener('play', this.update)
    })
  },
  update: function(video){
    this.setState({
      video: video
    })
  },
  componentWillUnmount: function() {
    this.state.listener.remove()
  },
  render : function() {
    if (this.state.video.live) {
      if(this.props.player && !this.props.player.broadcaster.isBroadcasting) return false
      if(this.props.player.liveBroadcastTitle){
        return(
          <div className="ss-now-playing">
            <h2 className="header"><i className="fa fa-tag"></i> Now Playing:</h2>
            <ul className="video-list">
              <h3><i className="fa fa-signal"></i> Live Broadcast</h3>
              <h4>{this.props.player.liveBroadcastTitle}</h4>
            </ul>
          </div>
        )
      }
      return (
        <div className="ss-now-playing">
          <h2 className="header"><i className="fa fa-tag"></i> Now Playing:</h2>
          <ul className="video-list">
            <h3><i className="fa fa-signal"></i> Live Broadcast</h3>
          </ul>
        </div>
      )
    } else if(this.state.video) {
      return (
        <div className="ss-now-playing">
          <h2 className="header"><i className="fa fa-tag"></i> Now Playing:</h2>
          <ul className="video-list">
            <CurrentArchive video={this.state.video}></CurrentArchive>
          </ul>
        </div>
      )
    } else {
      return false
    }
  }
})

var Sidebar = React.createClass({
  propTypes: {
    player: React.PropTypes.object.isRequired
  },
  getInitialState: function() {
    return {
      filterText: '',
      currentVideo: null,
      category: null,
      ready: false,
      videos: []
    }
  },
  componentDidMount(){
    this.props.player.getVideos(() => {
      this.setState({
        ready: true,
        videos: this.props.player.videos
      })
    })
  },
  handleUserSearch: function(filterText) {
    this.setState({filterText: filterText})
  },
  handleUserSelect: function(cat) {
    this.setState({category: cat})
  },
  render: function() {
    if(!this.state.ready) return <Loading/>
    var videos = this.state.videos
    return (
      <section className="recent-archives-section" style={{
        display: 'block'
      }}>
        <NowPlaying player={this.props.player}/>
        <h2 className="header">
          <i className="fa fa-archive"></i> Archives ({videos.length})
        </h2>
        <SearchBar player={this.props.player} filterText={this.state.filterText} onUserSelectInput={this.handleUserSelect} onUserSearchInput={this.handleUserSearch}/>
        <ArchiveList player={this.props.player} external={false} category={this.state.category} filterText={this.state.filterText} videos={videos}></ArchiveList>
      </section>
    )
  }
})

module.exports = Sidebar



// WEBPACK FOOTER //
// ./src/components/Sidebar.jsx